import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  FormControl,
  TextField,
  OutlinedInput,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import AxiosInstance from "../../components/Axios";
import MySelectField from "../../components/forms/MySelectField";
import MyTextField from "../../components/forms/MyTextField";
import MyDatePickerField from "../../components/forms/MyDatePickerField";
import MyMultiSelectField from "../../components/forms/MyMultiSelectField";
import Autocomplete from "@mui/material/Autocomplete";
import dayjs from "dayjs";
import colors from "../../components/constants/Colors";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const OwnerOptions = [
  "RDIUP",
  "FTK",
  "UKH",
  "NURO",
  "IRCCS-AOUBO",
  "UoM",
  "MoM",
  "CIP",
  "NION",
  "WIZ",
  "SWPS",
  "INT",
  "UoE",
  "HWU",
  "UNIBO",
];
const ExplotationTypes = ["Commercial", "Public"];
const KERTypes = [
  "Blueprint",
  "Commercial Solution",
  "Data Set / Data Pool",
  "Demonstrator",
  "Feasibility Study",
  "Framework (e.g. software environment, policy document, legal framework)",
  "Hardware (e.g. chip, appliance, drone, sensor)",
  "Infrastructure (e.g. IT infrastructure, energy infrastructure, water infrastructure, building, etc)",
  "Methodology",
  "Model (e.g. risk model, mathematical model, data model, physical model, business model, etc)",
  "Patent (e.g. utility, design patents and plant patents)",
  "Policy Report",
  "Prototype",
  "Proxy/broker service",
  "Research and/or virtual environment",
  "Scientific Publication (refereed)",
  "Scientific Publication (non-refereed)",
  "Software (e.g. routine, integrated platform, library, plugins)",
  "Standard (e.g. norms, policies)",
  "Taxonomy / Ontology",
  "Tools / Toolkit / Toolbox",
  "Training (e.g. learning tools, services, modules)",
  "White paper or similar publication",
  "Other (please specify)",
];

const EditKER = () => {
  const [partners, setPartners] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const { id: MyId } = useParams();
  const project_id = localStorage.getItem("project_id");
  const { id } = useParams();

  const location = useLocation();
  const { kerData } = location.state || {};

  console.log("location ker data", location.state);

  const navigate = useNavigate();

  const { handleSubmit, setValue, control, getValues } = useForm({
    defaultValues: {
      number_ker: "",
      type_ker: "",
      description: "",
      start_trl: null,
      end_trl: null,
      ownership: [],
      type_exploitation: "",
    },
    resolver: yupResolver(
      yup.object({
        number_ker: yup.string().required("Number KER is a required field"),
        type_ker: yup.string().required("Type KER is a required field"),
        description: yup.string().required("Description is a required field"),
        start: yup.number().required("Start TRL is a required field"),
        end: yup.number().required("End TRL is a required field"),
        //start_trl: yup.date(),
        //end_trl: yup.date(),
        ownership: yup.array().min(1, "Ownership is a required field"),
        type_exploitation: yup
          .string()
          .required("Type of exploitation is a required field"),
      })
    ),
  });

  useEffect(() => {
    console.log("kerData", kerData); // Check if kerData is available
    if (kerData) {
      setValue("number_ker", kerData.number_ker || "");
      setValue("type_ker", kerData.type_ker || "");
      setValue("description", kerData.description || "");
      setValue("start", kerData.start || "");
      setValue("end", kerData.end || "");
      setValue("type_exploitation", kerData.type_exploitation || "");
      const ownerIds =
        kerData.ownership_details?.map((owner) => owner.id) || [];
      setValue("ownership", ownerIds);
      setSelectedOwners(kerData.ownership_details || []);
    }
  }, [kerData, setValue]);

  // useEffect(() => {
  //   const fetchKERData = async () => {
  //     try {
  //       const res = await AxiosInstance.get(`ker/${MyId}`);
  //       setValue("number_ker", res.data.number_ker);
  //       setValue("type_ker", res.data.type_ker);
  //       setValue("description", res.data.description);
  //       setValue("start_trl", dayjs(res.data.start_trl));
  //       setValue("end_trl", dayjs(res.data.end_trl));
  //       setValue("type_exploitation", res.data.type_exploitation);

  //       const ownerIds = res.data.ownership_details
  //         ? res.data.ownership_details.map((owner) => owner.id)
  //         : [];
  //       setValue("ownership", ownerIds);
  //       setSelectedOwners(res.data.ownership_details || []);
  //     } catch (error) {
  //       console.error("Error fetching KER data:", error);
  //     }
  //   };

  //   fetchKERData();
  // }, [MyId, setValue]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await AxiosInstance.get(
          `projects/${project_id}/get_partners/`
        );
        if (response.status === 200) {
          setPartners(response.data);
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
      }
    };

    fetchPartners();
  }, [project_id]);

  const submission = async (data) => {
    console.log(data); // Check form data

    // const formattedStartTrl = data.start_trl
    //   ? dayjs(data.start_trl).format("YYYY-MM-DD")
    //   : null;
    // const formattedEndTrl = data.end_trl
    //   ? dayjs(data.end_trl).format("YYYY-MM-DD")
    //   : null;

    try {
      await AxiosInstance.put(`projects/${project_id}/ker/${MyId}/`, {
        number_ker: data.number_ker,
        type_ker: data.type_ker,
        description: data.description,
        // start_trl: formattedStartTrl,
        // end_trl: formattedEndTrl,
        start: data.start,
        end: data.end,
        ownership: data.ownership,
        type_exploitation: data.type_exploitation,
      });
      navigate(`/monitoring`);
      Swal.fire("Success", "KER updated successfully!", "success");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
    }
  };

  return (
    <div>
      <form
        onSubmit={handleSubmit((data) => {
          console.log("Form submitted with data:", data); // Check if form submission triggers
          submission(data);
        })}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: colors.secondary,
            marginBottom: "10px",
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
          }}
        >
          <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
            Edit a KER
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            boxShadow: 3,
            padding: 4,
            flexDirection: "column",
            marginTop: -1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <Controller
              name="number_ker"
              control={control}
              render={({ field }) => (
                <OutlinedInput
                  {...field}
                  type="number"
                  placeholder="Number of ker"
                  sx={{
                    width: "30%",
                    height: "45px", // Adjust the height here
                  }}
                />
              )}
            />
            <MySelectField
              label="Type of ker"
              name="type_ker"
              placeholder="Provide the type"
              control={control}
              width={"30%"}
              marginTop={15}
              options={KERTypes}
            />

            <MyTextField
              label="Description"
              name="description"
              placeholder="Enter the description"
              control={control}
              width={"30%"}
              marginTop={15}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <Controller
              name="start"
              control={control}
              render={({ field }) => (
                <OutlinedInput
                  {...field}
                  type="number"
                  placeholder="Provide START TRL"
                  sx={{
                    width: "30%",
                    height: "60px", // Adjust the height here
                  }}
                />
              )}
            />
            <Controller
              name="end"
              control={control}
              render={({ field }) => (
                <OutlinedInput
                  {...field}
                  type="number"
                  placeholder="Provide END TRL"
                  sx={{
                    width: "30%",
                    height: "60px", // Adjust the height here
                  }}
                />
              )}
            />

            <FormControl sx={{ width: 250 }} fullWidth>
              <Controller
                name="ownership" // Use the correct field name here
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    multiple
                    options={partners}
                    getOptionLabel={(option) =>
                      `${option.name} (${option.pic})`
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Add existing partners" />
                    )}
                    onChange={(event, value) => {
                      const ids = value.map((owner) => owner.id);
                      setValue("ownership", ids); // Use the correct field name here
                    }}
                    value={partners.filter((partner) =>
                      getValues("ownership")?.includes(partner.id)
                    )} // Use optional chaining to avoid errors
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <MySelectField
              label="Type of exploitation"
              name="type_exploitation"
              control={control}
              width={"30%"}
              options={ExplotationTypes}
            />
            <Box sx={{ width: "30%" }}>
              <Button
                variant="contained"
                type="submit"
                sx={{ width: "100%", backgroundColor: colors.secondary }}
              >
                Edit KER
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/")}
                sx={{ width: "100%", backgroundColor: colors.secondary, mt: 2 }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default EditKER;
